import React, {useEffect, useState} from 'react';
import {DatePicker} from '@material-ui/pickers';
import DateRangeIcon from '@material-ui/icons/DateRange';

function PeriodoPicker({value, onChange, anio, ...other}) {
   const [minDate, setMinDate] = useState(null);
   const [maxDate, setMaxDate] = useState(null);
   useEffect(() => {
      if (anio) {
         const ejercicioInt = parseInt(anio);
         const newMinDate = new Date(ejercicioInt, 0, 1);
         const newMaxDate = new Date(ejercicioInt, 11, 31);
         setMinDate(newMinDate);
         setMaxDate(newMaxDate);
         if (!value && typeof onChange === 'function') {
            const today = new Date();
            onChange(new Date(ejercicioInt, today.getMonth(), today.getDate()));
         }
      }
   }, [anio]);

   return (
      <DatePicker
         inputVariant="outlined"
         label="Periodo"
         margin="dense"
         variant="inline"
         autoOk
         {...other}
         value={value}
         onChange={onChange}
         minDate={minDate}
         maxDate={maxDate}
         views={['month', 'year']}
         format="yyyy-MM"
         InputProps={{startAdornment: <DateRangeIcon fontSize="small" />}}
      />
   );
}

export default PeriodoPicker;
